module.exports = __webpack_public_path__ + "img/lizihan.89ad798f.jpeg";